var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/admin/dashboard"}},[_c('img',{staticClass:"img-fluid for-light sidebarlogo",attrs:{"src":require("../../assets/image/shiv.png"),"alt":""}}),_c('img',{staticClass:"img-fluid for-dark sidebarlogo",attrs:{"src":require("../../assets/image/shiv.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }